import React from 'react';
import PropTypes from 'prop-types';
import CSSTransitionGroup from 'react-addons-css-transition-group';
import { urlReplace } from 'shared/modules';

export default function MainImage({ mainImage, sliderClassName, onClick, appear, appearActive }) {
  return (
    <span className={sliderClassName}>
      <CSSTransitionGroup
        transitionName={{
          appear,
          appearActive,
        }}
        transitionAppear
        transitionAppearTimeout={200}
        transitionEnter={false}
        transitionLeave={false}
        key={mainImage && mainImage.id}
      >
        <img
          className={sliderClassName}
          style={{ width: 'auto' }}
          id={mainImage && mainImage.id}
          src={urlReplace(mainImage && mainImage.image)}
          onClick={onClick}
          data-lens-event="showPhoto"
          alt=""
        />
      </CSSTransitionGroup>
    </span>
  );
}
MainImage.propTypes = {
  mainImage: PropTypes.shape({
    id: PropTypes.number.isRequired,
    image: PropTypes.string.isRequired,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  sliderClassName: PropTypes.string.isRequired,
  appear: PropTypes.string.isRequired,
  appearActive: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/desktop/components/AdvertPhotos/MainImage/MainImage.js